import { render } from "./productpage.vue?vue&type=template&id=63199d64"
import script from "./productpage.vue?vue&type=script&lang=js"
export * from "./productpage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\zytdwl\\zytdwl_cms\\zytdwl_cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__